import { loginRoute } from 'routes/routes';

/**
 * Login URL that returns the user to where they were, query string included.
 *
 * The query string is state, not decoration: a deep link from a notification
 * email carries what the destination needs to render (ai-presentations sends
 * `/presentations/templates/<deckId>/edit?tab=presentations&activity=<id>`,
 * where those two params are what opens the activity dialog). It has to be
 * encoded, or its params are parsed as params of the login URL itself and the
 * `redirect` value is truncated at the first `&`.
 */
export const loginRedirectUrl = (pathname: string, search: string): string => {
  if (pathname === loginRoute) {
    return loginRoute;
  }
  return `${loginRoute}?redirect=${encodeURIComponent(`${pathname}${search}`)}`;
};
